import React, { useCallback } from 'react';
import { AnyObject } from 'final-form';

import { createFormField } from 'Shared/utils/createFormField';

function PersonalMessage({ value, onChange }: AnyObject) {
  const handleChange = useCallback(event => onChange(event.target.value), [onChange]);

  return (
    <div>
      <div className="mt-4">Add Personalized Message</div>
      <textarea
        className="w-100 border rounded p-2 mt-1"
        value={value}
        onChange={handleChange}
        style={{ minHeight: '100px' }}
      />
    </div>
  );
}

export default createFormField(PersonalMessage);
